import React, { FC, useState } from 'react'
import { QueriesProps } from './types'
import TabTile from '../../../../../../data/components/TabTile'

export const Queries: FC<QueriesProps> = ({ queries }) => {
  const [queriesExpanded, setQueriesExpanded] = useState<boolean>(false)

  const handleToggleQueries = () => {
    setQueriesExpanded(!queriesExpanded)
  }

  return (
    <TabTile
      tab={{
        name: <span>{'Queries'}</span>,
      }}
      expanded={queriesExpanded}
      onChange={handleToggleQueries}>
      <div style={{ marginTop: '8px' }}>
        {queries?.map((q, i) => (
          <div
            key={i}
            style={{
              marginBottom: '16px',
              padding: '8px',
              border: '1px solid #e4e4e4',
              borderRadius: '6px',
            }}>
            <div style={{ fontSize: '14px', marginBottom: '4px' }}>
              <strong>Temperature:</strong> {q.temperature}
            </div>
            <pre
              style={{
                backgroundColor: '#fafafa',
                padding: '8px',
                borderRadius: '4px',
                fontSize: '13px',
              }}>
              {q.query}
            </pre>
          </div>
        ))}
      </div>
    </TabTile>
  )
}
